import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=39468080"
import script from "./page-header.vue?vue&type=script&lang=ts"
export * from "./page-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports